import React, { useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import './i18n/i18n';
import SessionFinderForm from './components/SessionFinderForm';
import SessionFinderWizardPage from './components/SessionFinderWizardPage';
import i18n from './i18n/i18n';
import { useTranslation } from 'react-i18next';

const theme = createTheme({
  direction: i18n.language === 'he' ? 'rtl' : 'ltr',
  typography: {
    fontFamily: 'Arial, sans-serif',
  },
});

const App: React.FC = () => {
  const { t, i18n } = useTranslation();
  const mode = new URLSearchParams(window.location.search).get('mode');

  useEffect(() => {
    document.title = process.env.REACT_APP_APP_TITLE || 'Session Finder';
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === 'he' ? 'rtl' : 'ltr';
  }, [t, i18n.language]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {mode === 'wizard' ? <SessionFinderWizardPage /> : <SessionFinderForm />}
    </ThemeProvider>
  );
};

export default App;